import React, { PureComponent } from 'react';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';
import { Waypoint } from 'react-waypoint';
import Certificate from 'Assets/images/pages/web-chat/certificate.svg';
import { shape, func, string, number } from 'prop-types';

import EmptyList from '../EmptyList';

import styles from './MedicalCertificate.less';

class MedicalCertificate extends PureComponent {
  componentDidMount() {
    const { getListCert, patientId, activeClinicTab } = this.props;
    getListCert({ page: 1, pageSize: 30, patientId, clinicId: activeClinicTab }, false);
  }

  handleWaypointEnter = () => {
    const {
      getListCert,
      certification: {
        status: { loading },
        meta: {
          pagination: { page },
        },
      },
      patientId,
      activeClinicTab,
    } = this.props;
    if (loading !== 0) {
      const isLoadMore = true;
      getListCert(
        { page: page + 1, pageSize: 30, patientId, clinicId: activeClinicTab },
        isLoadMore,
      );
    }
  };

  render() {
    const {
      certification: {
        list,
        meta: {
          pagination: { page, pages, total },
        },
      },
    } = this.props;
    return (
      <div>
        <div className={styles.listItem}>
          {list.map(item => {
            const type = item.certTypeName ? item.certTypeName : item.digiTypeInfo?.name;
            return (
              <a
                href={item?.digiFileUrl ?? item?.certFileInfo?.originalPath}
                target="_blank"
                className={styles.item}
                key={item.id}
                rel="noreferrer">
                <div className={styles.medicalType}>
                  <img src={Certificate} alt="mc" />
                  {type}
                </div>
                <div className={styles.date}>{moment(item.createdAt).format('MMM DD,YYYY')}</div>
                {/* <div className={styles.patient}>{`For ${item.patientName}`}</div> */}
              </a>
            );
          })}
        </div>
        {page < pages && (
          <Waypoint onEnter={this.handleWaypointEnter}>
            <div className="text-center">
              <Icon name="spinner" loading size="big" />
            </div>
          </Waypoint>
        )}

        {total === 0 && <EmptyList text="No MCs yet" />}
      </div>
    );
  }
}

MedicalCertificate.propTypes = {
  certification: shape({}).isRequired,
  getListCert: func.isRequired,
  patientId: string.isRequired,
  activeClinicTab: number.isRequired,
};

export default MedicalCertificate;
